// extracted by css-extract-rspack-plugin
export default {"sidebarSectionsLoadingContainer":"SidebarSectionsLoading-module__sidebarSectionsLoadingContainer__h6FH0wm"};